import ScrollIcon from './ScrollIcon';

export default ScrollIcon;
